import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { string2hex, hex2string, hex2rgb } from '@pixi/utils';
import { ExtensionType, extensions } from '@pixi/extensions';
var BackgroundSystem = /*#__PURE__*/function () {
  function BackgroundSystem() {
    _classCallCheck(this, BackgroundSystem);
    this.clearBeforeRender = true;
    this._backgroundColor = 0;
    this._backgroundColorRgba = [0, 0, 0, 1];
    this._backgroundColorString = "#000000";
    this.color = this._backgroundColor;
    this.alpha = 1;
  }
  _createClass(BackgroundSystem, [{
    key: "init",
    value: function init(options) {
      this.clearBeforeRender = options.clearBeforeRender;
      if (options.color) {
        this.color = typeof options.color === "string" ? string2hex(options.color) : options.color;
      }
      this.alpha = options.alpha;
    }
  }, {
    key: "color",
    get: function get() {
      return this._backgroundColor;
    },
    set: function set(value) {
      this._backgroundColor = value;
      this._backgroundColorString = hex2string(value);
      hex2rgb(value, this._backgroundColorRgba);
    }
  }, {
    key: "alpha",
    get: function get() {
      return this._backgroundColorRgba[3];
    },
    set: function set(value) {
      this._backgroundColorRgba[3] = value;
    }
  }, {
    key: "colorRgba",
    get: function get() {
      return this._backgroundColorRgba;
    }
  }, {
    key: "colorString",
    get: function get() {
      return this._backgroundColorString;
    }
  }, {
    key: "destroy",
    value: function destroy() {}
  }]);
  return BackgroundSystem;
}();
BackgroundSystem.extension = {
  type: [ExtensionType.RendererSystem, ExtensionType.CanvasRendererSystem],
  name: "background"
};
extensions.add(BackgroundSystem);
export { BackgroundSystem };